<template>
  <d2-container>
    <div class="tech">
      <div class="techbanner">
        <div class="techbasecont">
          <h3>算力城市云平台</h3>
          <h4>支撑AI技术研发与应用的核心基础设施</h4>
        </div>
      </div>

      <div class="techSection2">
        <div class="techbasecont">
          <div class="rf techsection2lft">
            <img src="/image/portalimg/platform/techSection2.png" alt="">
          </div>
          <div class="lf techsection2rt pgf">
            <p>
              智能算力的应用，面临着算力供应方式复杂、多元化芯片适配、应用与算力融合构建等一系列严峻的新挑战。
            </p>
            <p>
              算力城市云平台为智能算力应用提供了软件层的一站式解决方案，从操作系统、IaaS管理，到模型开发、模型训练，
              再到推理服务部署、AI应用的各个层次提供了支撑，形成完整的算力管理到应用发布的软件支撑体系。
            </p>
          </div>

        </div>
      </div>

      <div class="techSection3">
        <div class="techbasecont">
          <div class="lf techsection3rt">
            <img src="/image/portalimg/platform/techSection3.png" alt="">
          </div>
          <div class="rf techsection3lft">
            <h2>专业而高效的算法开发/模型训练/服务发布平台</h2>
            <table>
              <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
                <td class="li-content">提供优化后的底层能力支持和工具支持，让算法研究和开发人员可以专注于创新</td>
              </tr>
              <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
                <td class="li-content">屏蔽复杂的底层资源配置，提升开发效率，让用户的工作专注与价值的创造</td>
              </tr>
              <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
                <td class="li-content">一站式模型管理、版本控制及在线推理和远程服务调用</td>
              </tr>
              <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
                <td class="li-content">支持多种主流AI框架，如PyTorch、TensorFlow、Keras，并提供自定义扩展功能</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="techbasecont" style="margin-top: 40px;">
          <div class="rf techsection4lft">
            <img src="/image/portalimg/platform/techSection4.png" alt="" >
          </div>
          <div class="lf techsection4rt">
            <h2>面向人工智能技术的算力优化</h2>
            <p>基于集群网络拓扑感知、算力资源调度优化、GPU虚拟化与透传等技术，提供高效的算力调度、模型训练与推理加速框架</p>
          </div>
        </div>

        <div class="techbasecont">
          <div class="lf techsection5rt">
            <img src="/image/portalimg/platform/techSection5.png" alt="" >
          </div>
          <div class="rf techsection5lft">
            <h2>人工智能应用敏捷开发与发布</h2>
            <p class="pgf">
              致力于降低人工智能行业应用的开发与落地门槛，提供敏捷易用的应用开发平台，“五分钟内创建和发布大模型应用”。无论您是视频、图像、文本还是语音处理，我们都为您提供了一站式解决方案，包括向量知识库构建、提示词工程环境以及便捷的服务发布。
            </p>
          </div>
        </div>

        <div class="techbasecont">
          <div class="rf techsection6lft">
            <img src="/image/portalimg/platform/techSection6.png" alt="" >
          </div>
          <div class="lf techsection6rt">
            <h2>高度灵活弹性的算力调配</h2>
            <table>
              <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
                <td class="li-content">面向不同算力用户的不同应用场景，提供裸金属、虚拟机、容器云、MaaS/SaaS等不同形态的算力资源</td>
              </tr>
              <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
                <td class="li-content">安全可靠的文件存储，支持文件共享机制，满足团队协作的数据共享需求</td>
              </tr>
              <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
                <td class="li-content">弹性调度GPU等异构资源算力，实现多租户体系下的资源精细化管理</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div class="techbasecont">
        <div class="lf techsection8lft">
          <img src="/image/portalimg/platform/techSection7.png" alt="">
        </div>
        <div class="rf techsection8rt">
          <h2>坚不可摧的安全防护</h2>
          <table>
            <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
              <td class="li-content">先进的安全防护技术：以“内容投影+AI模型检测”为核心技术，打造的大模型应用安全防御产品，为应用提供“绝对防御”能力</td>
            </tr>
            <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
              <td class="li-content">保护数据隐私：确保用户数据不泄露，同时让用户能够正常访问应用，彻底屏蔽外部自动化攻击</td>
            </tr>
            <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
              <td class="li-content">对用户透明的安全防护：用户不需要安装专有安全终端软硬件，使用常规浏览器即可享受安全防护</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="techbasecont">
        <div class="rf techsection9rt">
          <img src="/image/portalimg/platform/techSection8.png" alt="">
        </div>
        <div class="lf techsection9lft">
          <h2>私有化部署</h2>
          <table>
            <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
              <td class="li-content">定制化服务：针对不同行业和企业的特定需求，提供定制化的私有化部署方案，确保平台与现有IT架构无缝集成</td>
            </tr>
            <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
              <td class="li-content">数据主权：所有数据保留在企业内部，保证数据主权和隐私保护，适合对数据安全要求极高的行业，如金融、医疗等</td>
            </tr>
            <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
              <td class="li-content">高性能与稳定性：通过本地部署获得更低的延迟和更高的性能，同时确保系统稳定运行，不受公共云服务中断的影响</td>
            </tr>
            <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
              <td class="li-content">灵活的资源管理：根据业务发展需要，弹性调整计算资源，实现资源利用的最大化</td>
            </tr>
            <tr><td class="li-icon"><i class="el-icon-circle-check" /></td>
              <td class="li-content">全方位的技术支持：从部署前咨询规划到部署后维护升级，我们提供端到端的专业技术支持和服务，确保客户无后顾之忧</td>
            </tr>
          </table>
        </div>

      </div>

      <div class="techbgCenter">
        <div class="techbasecont">
          <div class="techsection7">
            <h2>全面拥抱国产化算力设备</h2>
            <div class="techsection7cont">
              <dl>
                <dt>多样化算力支持</dt>
                <dd>不仅支持通用芯片，还全面兼容国产<br/>芯片，为客户提供丰富的选择。</dd>
              </dl>
              <dl>
                <dt>多层次适配优化</dt>
                <dd>在虚拟机、容器、操作系统等多个层次进<br/>行了适配和优化，确保最佳性能表现。</dd>
              </dl>
              <dl>
                <dt>生态合作</dt>
                <dd>积极与国内厂商合作，共同推动国产<br/>化软硬件生态系统的完善和发展。</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <div class="techbgBottom">
        <div class="techbasecont">
          <div class="techbgBottomCont">
            <h4>让我们一起开启智能未来</h4>
            <p>加入算力城市大家庭，携手共创更加智能化的世界。</p>
            <p>立即联系我们，了解如何将算力云集成到您的业务中，开始您的智能转型之旅！</p>
          </div>
        </div>
      </div>

      <base-bottom></base-bottom>

    </div>
  </d2-container>
</template>

<script>

import baseBottom from '../components/base-bottom'

export default {
  name: 'tech',
  components: {
    baseBottom
  },
  data() {
    return {}
  },
}
</script>

<style scoped>

*, body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  color: #000000;
}

.tech {
  font-family: "Arial", "Microsoft YaHei", "微软雅黑", "黑体", "宋体", sans-serif;
  letter-spacing: 2.53px;
}

.lf {
  float: left;
}

.rf {
  float: right;
}

.pgf {
  text-indent: 2em;
}

@media (min-width: 769px) {
    /* PC端样式 */

.li-icon {
  width: 32px;
  vertical-align: top;
  font-size: 16px;
  padding-top: 8px;
  padding-left: 3px;
  padding-right: 10px;
}
.li-content {
  vertical-align: top;
  font-size: 16px;
  color: #000000;
  letter-spacing: 1.68px;
  line-height: 35px;
  font-weight: 500;
}

.techbanner {
  background: url("/image/portalimg/platform/banner.png") no-repeat center center;
  height: auto;
}

.techbasecont {
  width: 1500px;
  margin: 0 auto;
  overflow: hidden;
}

.techbasecont h3 {
  padding-top: 208px;
  padding-bottom: 25px;
  font-size: 48px;
  letter-spacing: 4.2px;
  text-align: center;
  line-height: 66px;
  font-weight: 400;
}

.techbasecont h4 {
  font-size: 16px;
  letter-spacing: 21.1px;
  text-align: center;
  font-weight: 400;
  padding-bottom: 193px;
}

.techsection2lft {
  width: 765px;
  line-height: 43px;
  font-weight: 400;
  margin: 92px 0 60px;
}

.techsection2rt {
  width: 610px;
  margin-top: 125px;
  font-size: 16px;
  line-height: 43px;
}

.techSection3 {
  background: #F3F7FF;
}

.techsection3lft {
  width: 584px;
}

.techsection3lft h2 {
  font-size: 24px;
  color: #0045A4;
  letter-spacing: 2.53px;
  text-align: center;
  font-weight: 600;
  padding: 84px 0 40px;
}

.techsection3lft ol li {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1.68px;
  line-height: 35px;
  font-weight: 500;
}

.techsection3rt {
  width: 827px;
  padding-top: 133px;
}

.techsection4lft {
  width: 712px;
  padding-top: 82px;
}

.techsection4lft h2 {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1.68px;
  font-weight: 500;
  text-align: center;
}

.techsection4rt {
  width: 611px;
  padding-top: 164px;
}

.techsection4rt h2 {
  font-size: 24px;
  color: #0045A4;
  letter-spacing: 2.53px;
  font-weight: 600;
  padding-bottom: 32px;
}

.techsection4rt p {
  font-size: 16px;
  letter-spacing: 1.68px;
  line-height: 35px;
  font-weight: 500;
}

.techsection5lft {
  width: 584px;
  padding-top: 155px;
}

.techsection5lft h2 {
  font-size: 24px;
  color: #0045A4;
  letter-spacing: 2.53px;
  font-weight: 600;
  padding-bottom: 32px;
}

.techsection5lft p {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1.68px;
  line-height: 35px;
  font-weight: 500;
}

.techsection5rt {
  width: 728px;
  padding-top: 110px;
}

.techsection6lft {
  width: 730px;
  padding: 170px 0 124px;
}

.techsection6rt {
  width: 611px;
  padding-top: 173px;
}

.techsection6rt h2 {
  font-size: 24px;
  color: #0045A4;
  letter-spacing: 2.53px;
  font-weight: 600;
  padding-bottom: 32px;
}

.techsection6rt ol li {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1.68px;
  line-height: 35px;
  font-weight: 500;
}

.techbgCenter {
  height: 376px;
  background: url("/image/portalimg/platform/techbgCenter.png") no-repeat center center;
}

.techsection7 h2 {
  text-align: center;
  font-size: 32px;
  color: #000000;
  letter-spacing: 3.37px;
  font-weight: 400;
  padding: 44px 0 48px;
}

.techsection7cont {
  display: flex;
  justify-content: center;
}

.techsection7cont dl {
  width: 442px;
  height: 194px;
  background-image: linear-gradient(180deg, #FAFAFA 0%, #FFFFFF 18%, #FFFFFF 74%, #F4F4F4 100%);
  border-radius: 8px;
  margin-right: 50px;
}

.techsection7cont dl dt {
  font-size: 24px;
  letter-spacing: 2.53px;
  text-align: center;
  line-height: 33px;
  font-weight: 600;
  padding-top: 44px;
}

.techsection7cont dl dd {
  padding-top: 30px;
  font-size: 16px;
  color: #555;
  letter-spacing: 1.68px;
  text-align: center;
}

.techsection8lft {
  width: 768px;
  padding-top: 148px;
}

.techsection8rt {
  width: 604px;
}

.techsection8rt h2 {
  padding-top: 130px;
  font-size: 24px;
  color: #0045A4;
  letter-spacing: 2.53px;
  font-weight: 600;
  padding-bottom: 32px;
}

.techsection8rt ol li {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1.68px;
  line-height: 35px;
  font-weight: 500;
}

.techsection9lft {
  width: 527px;
}

.techsection9lft h2 {
  padding-top: 126px;
  font-size: 24px;
  color: #0045A4;
  letter-spacing: 2.53px;
  font-weight: 600;
  padding-bottom: 32px;
}

.techsection9lft ol li {
  font-size: 16px;
  letter-spacing: 1.68px;
  line-height: 30px;
  font-weight: 500;
}

.techsection9rt {
  width: 634px;
  padding-top: 131px;
  padding-bottom: 80px;
}

.techbgBottom {
  height: 376px;
  background: url("/image/portalimg/platform/techbgBottom.png") no-repeat center center;
}

.techbgBottomCont h4 {
  font-size: 32px;
  color: #FFFFFF;
  letter-spacing: 3.37px;
  font-weight: 600;
  padding: 102px 0 27px;
  text-align: center;
}

.techbgBottomCont p {
  font-size: 18px;
  color: #FFFFFF;
  line-height: 40px;
  letter-spacing: 1.89px;
  text-align: center;
  font-weight: 400;
}

}
@media (max-width: 768px) {
    /* 移动端样式 */

  .li-icon {
    width: 32px;
    vertical-align: top;
    font-size: 16px;
    padding-top: 8px;
    padding-left: 3px;
    padding-right: 10px;
  }
  .li-content {
    vertical-align: top;
    font-size: 14px;
    color: #000000;
    letter-spacing: 1px;
    line-height: 28px;
    font-weight: normal;
  }

  .techbanner {
    background: url("/image/portalimg/platform/banner.png") no-repeat center center;
    height: auto;
    background-size: 100% 100%;
  }

  .techbasecont {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
  }

  .techbasecont h3 {
    padding-top: 80px;
    padding-bottom: 0px;
    font-size: 23px;
    letter-spacing: 4px;
    text-align: center;
    line-height: 50px;
    font-weight: 400;
  }

  .techbasecont h4 {
    font-size: 14px;
    letter-spacing: 2px;
    text-align: center;
    font-weight: 400;
    padding-bottom: 27px;
  }

  .techsection2lft {
    width: 95%;
    line-height: 43px;  
    margin: 20px 2%;
  }

  .techsection2rt {
    width: 95%;
    margin: 10px 2% 25px;
    /* margin-top: 10px; */
    font-size: 14px;
    line-height: 24px;
  }

.techSection3 {
  background: #F3F7FF;
}

.techsection3lft {
  width: 95%;
  margin: 0 2%;
}

.techsection3lft h2 {
  font-size: 17px;
  color: #0045A4;
  letter-spacing: 2px;
  text-align: center;
  font-weight: 600;
  padding: 50px 0 20px;
}

.techsection3lft ol li {
  font-size: 14px;
  color: #000000;
  letter-spacing: 1.68px;
  line-height: 29px;
  font-weight: 500;
}

.techsection3rt {
  width: 95%;
  margin: 20px 2%;
}

.techsection4lft {
  width: 95%;
  margin: 20px 2%;
}

.techsection4lft h2 {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1.68px;
  font-weight: 500;
  text-align: center;
}
.techsection4rt {
  width: 95%;
  margin: 10px 2%;
}

.techsection4rt h2 {
  font-size: 17px;
  color: #0045A4;
  letter-spacing: 2px;
  font-weight: 600;
  padding-bottom: 20px;
}

.techsection4rt p {
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 28px;
  font-weight: 500;
}

.techsection5lft {
  width: 95%;
  margin: 20px 2%;
}

.techsection5lft h2 {
  font-size: 17px;
  color: #0045A4;
  letter-spacing: 2px;
  font-weight: 600;
  padding-bottom: 20px;
}

.techsection5lft p {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1.68px;
  line-height: 28px;
  font-weight: 500;
}

.techsection5rt {
  width: 95%;
  margin: 20px 2%;
}

.techsection6lft {
  width: 95%;
  margin: 20px 2%;
}

.techsection6rt {
  width: 95%;
  margin: 20px 2%;
}

.techsection6rt h2 {
  font-size: 17px;
  color: #0045A4;
  letter-spacing: 2px;
  font-weight: 600;
  padding-bottom: 20px;
}

.techsection6rt ol li {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1px;
  line-height: 28px;
  font-weight: 500;
}

.techbgCenter {
  background: url("/image/portalimg/platform/techbgCenter.png") no-repeat center center;
  background-size: 100% 100%;
}

.techsection7 h2 {
  text-align: center;
  font-size: 18px;
  color: #000000;
  letter-spacing: 3px;
  font-weight: 400;
  padding-top: 20px;
}

.techsection7cont {
  /* display: flex;
  justify-content: center; */
}

.techsection7cont dl {
  width: 95%;
  background-image: linear-gradient(180deg, #FAFAFA 0%, #FFFFFF 18%, #FFFFFF 74%, #F4F4F4 100%);
  border-radius: 8px;
  margin: 20px 2%;
  padding-bottom: 20px;
}

.techsection7cont dl dt {
  font-size: 15px;
  letter-spacing: 2px;
  text-align: center;
  line-height: 33px;
  font-weight: 600;
  padding-top: 20px;
}

.techsection7cont dl dd {
  font-size: 14px;
  color: #555;
  letter-spacing: 1.68px;
  text-align: center;
}

.techsection8lft {
  width: 95%;
  margin: 20px 2%;
}

.techsection8rt {
  width: 95%;
  margin: 20px 2%;
}

.techsection8rt h2 {
  padding-top: 30px;
  font-size: 17px;
  color: #0045A4;
  letter-spacing: 2px;
  font-weight: 600;
  padding-bottom: 20px;
}

.techsection8rt ol li {
  font-size: 16px;
  color: #000000;
  letter-spacing: 1px;
  line-height: 28px;
  font-weight: 500;
}

.techsection9lft {
  width: 95%;
  margin: 20px 2%;
}

.techsection9lft h2 {
  padding-top: 20px;
  font-size: 17px;
  color: #0045A4;
  letter-spacing: 2px;
  font-weight: 600;
  padding-bottom: 20px;
}

.techsection9lft ol li {
  font-size: 16px;
  letter-spacing: 1.68px;
  line-height: 30px;
  font-weight: 500;
}

.techsection9rt {
  width: 95%;
  margin: 20px 2%;
}

.techbgBottom {
  background: url("/image/portalimg/platform/techbgBottom.png") no-repeat center center;
  padding-bottom: 20px;
}

.techbgBottomCont h4 {
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 3px;
  font-weight: 600;
  padding: 25px 0 10px;
  text-align: center;
}

.techbgBottomCont p {
  width: 74%;
  margin: 0px 13% 6px;
  font-size: 10px;
  color: #FFFFFF;
  line-height: 20px;
  letter-spacing: 1px;
  text-align: center;
  font-weight: 400;
}
}
</style>
